import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadDashboardData } from '../../../shared/dashboard/dashboard.actions';
import { loadNavigation } from '../../../shared/navigation/navigation.actions';
import { IRootState } from '../../app.config';
import { NgOptimizedImage } from '@angular/common';
import { BrandingLogoDisplayComponent } from '../../../shared/branding/branding-logo-display/branding-logo-display.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [NgOptimizedImage, BrandingLogoDisplayComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {


  constructor(private store$: Store<IRootState>) { }

  ngOnInit() {
    this.store$.dispatch(loadNavigation());
    this.store$.dispatch(loadDashboardData());
  }
}
